"use client";

import { c as _c } from "react/compiler-runtime";
import { ArrowRight } from "lucide-react";
import Link from "next/link";
import { cn } from "@/lib/utils";
import { ProviderPromoContent, useProviderPromo } from "@llmgateway/shared/components";
interface ProviderPromoBannerProps {
  // Collapses the banner once the floating navbar pill takes over on scroll.
  collapsed?: boolean;
}
export function ProviderPromoBanner(t0) {
  const $ = _c(12);
  const {
    collapsed: t1
  } = t0;
  const collapsed = t1 === undefined ? false : t1;
  const promo = useProviderPromo();
  if (!promo) {
    return null;
  }
  const t2 = collapsed || undefined;
  const t3 = collapsed ? "grid-rows-[0fr] opacity-0" : "grid-rows-[1fr] opacity-100";
  let t4;
  if ($[0] !== t3) {
    t4 = cn("grid transition-[grid-template-rows,opacity] duration-300 ease-out motion-reduce:transition-none", t3);
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ArrowRight aria-hidden="true" className="h-3.5 w-3.5 shrink-0 transition-transform duration-200 ease-out group-hover/promo:translate-x-0.5 motion-reduce:transition-none motion-reduce:transform-none" />;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== promo) {
    t6 = <ProviderPromoContent key={promo.id} promo={promo} trailing={t5} />;
    $[3] = promo;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== promo.announcementPath || $[6] !== t6) {
    t7 = <div className="min-h-0 overflow-hidden"><div className="mx-auto max-w-[1400px] pt-2"><Link href={promo.announcementPath} prefetch={true} className="group/promo flex flex-wrap items-center justify-center gap-x-2.5 gap-y-2 rounded-2xl border border-neutral-200 bg-white px-4 py-2.5 text-neutral-950 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-current dark:border-white/15 dark:bg-neutral-950 dark:text-white">{t6}</Link></div></div>;
    $[5] = promo.announcementPath;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t2 || $[9] !== t4 || $[10] !== t7) {
    t8 = <div inert={t2} className={t4}>{t7}</div>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
}